import './styles.scss'
import React from 'react'
import { Tooltip } from 'reactstrap'

export default class Index extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
    }

    this.tooltipToggle = this.tooltipToggle.bind(this)
  }

  componentDidMount() {
    if (this.props.isOpen) this.setState({ isOpen: true })
  }

  tooltipToggle() {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }))
  }

  render() {
    return (
      <span className='info-tooltip' hidden={this.props.hidden}>
        <i className='fa fa-info-circle' id={this.props.targetId}>
          <Tooltip
            placement={this.props.position || 'top'}
            isOpen={this.state.isOpen}
            toggle={this.tooltipToggle}
            target={this.props.targetId}
            autohide={this.props.autohide || false}
          >
            {this.props.text || 'Nothing to show'}
          </Tooltip>
        </i>
      </span>
    )
  }
}
